<template>
  <div v-if="ready" class="lab-form-sheet">
    <div v-if="showTitle" class="origin-form-title">{{ title }}</div>
    <PaperFormTable
      :rows="sheetRows"
      :model="model"
      :total-cols="totalCols"
      :form-num="formNum"
      :fk-map="fkMap"
      :xmbh="xmbh"
      :ypbh="ypbh"
      :join-top="!showTitle && joinTop"
      :col-weights="colWeights"
    />
  </div>
  <div v-else-if="loadFailed" class="origin-loading origin-loading--err">原表版式 GSYN-{{ formNum }} 未配置（缺少 _layout）</div>
  <div v-else class="origin-loading">正在加载原表版式…</div>
</template>

<script>
import PaperFormTable from '@/components/PaperFormTable.vue'
import {
  loadFormTemplate,
  formHasPaperLayout,
  formTitle,
  rowsForScope,
  colWeightsFromRows,
  layoutFromTpl
} from '@/utils/lab_form_engine'
import formFkMaps from '../../../config/form_fk_maps.json'

export default {
  name: 'LabFormSheet',
  components: { PaperFormTable },
  props: {
    formNum: { type: String, required: true },
    model: { type: Object, required: true },
    scope: { type: String, default: 'batch' },
    xmbh: { type: String, default: '' },
    ypbh: { type: String, default: '' },
    showTitle: { type: Boolean, default: true },
    joinTop: { type: Boolean, default: false }
  },
  data() {
    return { tpl: null, loadFailed: false }
  },
  computed: {
    ready() {
      return formHasPaperLayout(this.tpl, this.scope)
    },
    totalCols() {
      return (this.tpl && this.tpl.cols) || 18
    },
    title() {
      return formTitle(this.tpl)
    },
    sheetRows() {
      return rowsForScope(this.tpl, this.scope)
    },
    colWeights() {
      return colWeightsFromRows(this.sheetRows, this.totalCols)
    },
    fkMap() {
      const num = String(this.formNum || '').replace(/\D/g, '')
      const fromTpl = (this.tpl && this.tpl._fkMap) || {}
      const fromCfg = (formFkMaps && formFkMaps[num]) || {}
      return { ...fromCfg, ...fromTpl }
    }
  },
  watch: {
    formNum: {
      immediate: true,
      handler() {
        this.fetchTpl()
      }
    }
  },
  methods: {
    async fetchTpl() {
      this.loadFailed = false
      this.tpl = null
      const num = String(this.formNum || '').replace(/\D/g, '')
      if (!num) {
        this.loadFailed = true
        return
      }
      const tpl = await loadFormTemplate(num)
      if (!formHasPaperLayout(tpl, this.scope)) {
        this.loadFailed = true
        return
      }
      this.tpl = tpl
    }
  }
}
</script>

<style scoped>
.lab-form-sheet {
  margin-bottom: 8px;
}
.origin-loading {
  padding: 24px;
  text-align: center;
  color: #909399;
}
.origin-loading--err {
  color: #e6a23c;
}
.origin-form-title {
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  padding: 10px 8px;
  border: 1px solid #333;
  border-bottom: none;
  background: #fff;
}
</style>
